import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const postLiveQuizEvent = (data) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.POST,
    apiConstants.EVENTS.POST_LIVE_QUIZ_EVENT,
    data,
    cancelToken
  );
};

export default postLiveQuizEvent;
